import m from "../../geodata/es2015/tajikistanLow";
window.am4geodata_tajikistanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/tajikistanLow.js
// module id = null
// module chunks = 